export default __webpack_public_path__ + "3eeeec4c982b00edc1baacda581a62c2.png";